import React from 'react';
import App from './App';
import Main from './Main';
import './helpers/initFA';
import './assets/scss/user.scss';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { setupStore } from './reduxStore';
import 'react-toastify/dist/ReactToastify.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const container = document.getElementById('main');
const root = createRoot(container!);
const queryClient = new QueryClient();
export const store = setupStore();

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <Main>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </Main>
    </Provider>
  </BrowserRouter>
);
